export default __webpack_public_path__ + "static/poster-1c023c601949e70d708115bdd90cba36.jpg";